import { animate, AnimationBuilder, AnimationPlayer, style } from "@angular/animations";
import { AfterViewChecked, Directive, ElementRef, EventEmitter, Input, Output } from "@angular/core";

@Directive({ selector: "[obgAnimateDialogHeightResize]" })
export class AnimateDialogHeightResizeDirective implements AfterViewChecked {
	@Input() containerElement: HTMLElement | undefined;
	@Input() extraHeight = 0;
	@Input() height: number | undefined;

	@Output() animationStart = new EventEmitter();
	@Output() animationDone = new EventEmitter();

	private animationPlayer: AnimationPlayer | undefined;
	private animatedElementHeight = 0;

	constructor(
		public animationBuilder: AnimationBuilder,
		private el: ElementRef
	) {}

	ngAfterViewChecked() {
		const { height } = this.el.nativeElement.getBoundingClientRect();

		if (!this.containerElement || this.animatedElementHeight === height + this.extraHeight) {
			return;
		}

		if (this.height) {
			this.animatedElementHeight = this.height;
		}

		this.animatedElementHeight = height + this.extraHeight;
		const animation = this.animationBuilder.build([
			style({ height: "*" }),
			animate(300, style({ height: this.animatedElementHeight })),
		]);
		this.animationPlayer = animation.create(this.containerElement);
		this.animationPlayer.onStart(() => this.animationStart.emit());
		this.animationPlayer.play();
		this.animationPlayer.onDone(() => this.animationDone.emit());
	}
}
